import LoadingIcon from "../../../icons/LoadingIcon";

const Loader = () => {
  return <LoadingIcon className="w-[2em] h-[1.555em] !bg-none" />;
};

export default Loader;
